import { useEffect, useRef } from "react";
import type { ComponentType } from "react";

import { useMultiStepFormStore } from "@/stores";
import ProgressBar from "@/ui/common/ProgressBar";
import { TOTAL_FORM_STEPS, tw } from "@/utils";
import AddressInformationForm from "./AddressInformationForm";
import { CardsSection } from "./CardsSection";
import DoctorInformationForm from "./DoctorInformationForm";
import GeneralInformationForm from "./GeneralInformationForm";
import { InsuranceInformationForm } from "./insuranceInformationForm";
import { MedicalInformationForm } from "./MedicalInformationForm";
import ProductInformationForm from "./ProductInformationForm";
import ReviewInformationForm from "./ReviewInformationForm";
import { TransferForm } from "./TransferForm";

const stepComponents: Record<number, ComponentType> = {
  1: () => <GeneralInformationForm />,
  2: () => <MedicalInformationForm />,
  3: () => <InsuranceInformationForm />,
  4: () => <AddressInformationForm />,
  5: () => <ProductInformationForm />,
  6: () => <DoctorInformationForm />,
  7: () => <ReviewInformationForm />,
  8: () => <TransferForm />,
};

export const IntakeMultiStep = () => {
  const { currentFormStep } = useMultiStepFormStore();

  const StepComponent = stepComponents[currentFormStep];

  const progressPercentage =
    currentFormStep * (100 / Object.keys(stepComponents).length);
  const isReviewStep = currentFormStep === TOTAL_FORM_STEPS - 1;
  const isLastStep = currentFormStep === TOTAL_FORM_STEPS;

  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [currentFormStep]);

  return (
    <div className={"grid grid-cols-12 gap-6"}>
      {!isReviewStep && (
        <aside className="col-span-4">
          <CardsSection />
        </aside>
      )}

      <div
        ref={formRef}
        className={tw(
          "col-span-8 flex flex-col gap-y-10",
          isReviewStep && "col-start-3",
        )}
      >
        {!isReviewStep && !isLastStep && (
          <ProgressBar progressPercentage={progressPercentage} />
        )}
        {StepComponent ? <StepComponent /> : <div>Step not found</div>}
      </div>
    </div>
  );
};
